export const properties = {
    backendApi: import.meta.env.VITE_API_LOCATION,
};